import styled from 'styled-components';
import media from 'styled-media-query';
import { Formik, Form as FormikForm, FieldArray as Field } from 'formik';

import colors from 'themes/Main';

const {
  white,
  darkBlue,
  danger,
  pink,
  success,
  gray01,
  gray02,
  gray03,
} = colors;

const getStatusColor = id => {
  switch (id) {
    case 1:
      return pink;
    case 2:
      return success;
    case 3:
      return danger;
    default:
      return '';
  }
};

export const Container = styled.div`
  background-color: ${white};
  border-radius: 10px;
  box-shadow: 0px 1px 8px rgba(215, 220, 230, 0.2),
    0px 3px 4px rgba(215, 220, 230, 0.12), 0px 3px 3px rgba(215, 220, 230, 0.14);
  height: ${({ hasState }) => (hasState ? 'auto' : '100%')};
  padding: 32px;
  overflow-x: hidden;

  ${media.lessThan('medium')`
    margin: 32px 0;
  `}
`;

export const AppointmentByPersonContainer = styled(Container)`
  height: auto;
  margin-bottom: 24px;
  padding: 24px 32px;
`;

export const AppointmentByPersonTitle = styled.p`
  color: ${gray02};
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0;
`;

export const PersonName = styled.p`
  color: ${darkBlue};
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  margin: 8px 0;
`;

export const PersonFunction = styled.p`
  color: ${gray02};
  font-size: 14px;
  margin-bottom: 0;

  span {
    font-weight: 700;
    margin-right: 4px;
  }
`;

export const AdminJustification = styled.div`
  margin-bottom: -8px;
  margin-top: 40px;
`;

export const FormHeader = styled.p`
  color: ${gray03};
  font-size: 14px;
  font-weight: 700;
  position: relative;
  text-transform: uppercase;
`;

export const FormHistory = styled.button`
  background: transparent;
  border: 0;
  color: ${darkBlue};
  font-size: 14px;
  text-decoration: underline;
  transition: opacity 0.3s ease-out;

  &:hover {
    opacity: 0.6;
  }
`;

export const FormWrapper = styled(Formik)``;

export const Form = styled(FormikForm)``;

export const AppointmentsContainer = styled.div``;

export const FieldArray = styled(Field)``;

export const AppointmentCard = styled.div`
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  box-shadow: 0px 3px 4px rgba(215, 220, 230, 0.12),
    0px 1px 5px rgba(215, 220, 230, 0.2), 0px 2px 4px rgba(215, 220, 230, 0.14);
  padding: 32px 24px;

  &:not(:last-child) {
    margin-bottom: 32px;
  }

  > input {
    width: 100% !important;
  }
`;

export const AppointmentStatus = styled.small`
  color: ${gray01};
  font-size: 13px;
  margin-top: 8px;
`;

export const Status = styled.span`
  color: ${({ status }) => `${getStatusColor(status)}`};
  font-weight: 700;
  left: 4px;
  position: relative;
`;

export const AppointmentActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const RemoveAppointment = styled.button`
  align-items: center;
  background-color: transparent;
  border: 0;
  color: ${danger};
  display: flex;
  font-size: 14px;
  transition: opacity 0.3s ease-out;

  &:hover {
    opacity: 0.6;
  }

  &:disabled {
    opacity: 0.4;
  }

  svg {
    margin-right: 4px;
  }
`;

export const AppointmentExtraHour = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.07);
  margin-top: 32px;
  padding-top: 16px;
`;

export const ExtraHourTitle = styled.p`
  color: ${darkBlue};
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const ExtraHourItem = styled.p`
  color: ${gray01};
  font-size: 14px;
  margin-bottom: 8px;

  span {
    color: ${gray02};
    font-weight: 700;
    padding-right: 4px;
  }
`;

export const AddAppointment = styled.div`
  display: flex;
  margin-top: 32px;
  justify-content: flex-end;
`;

export const ExtraHourContainer = styled.div`
  margin-top: 16px;
`;

export const FormActions = styled.div`
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
`;

export const CallbackContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 64px 32px;
  width: 100%;
`;

export const CallbackText = styled.p`
  color: ${gray03};
  font-weight: 600;
  margin-top: 24px;
  text-align: center;
`;
